const ACCESS_TOKEN_AGP_KEY = '@barfacil-adm/access-token-agp'
const ACCESS_TOKEN_BF_KEY = '@barfacil-adm/access-token-bf'
export { ACCESS_TOKEN_AGP_KEY, ACCESS_TOKEN_BF_KEY }
